// Gerador e medidor de senha, comuns ao cartao da senha do login (SenhaCard) e ao da
// senha UNIX (SenhaUnixCard). Moram aqui, e nao num dos dois, porque as duas senhas
// passam pela MESMA lista de senhas proibidas do Kanidm: medidor diferente em cada
// cartao diria "Forte" para uma senha que o outro chama de "Fraca".

const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
const LOWER = 'abcdefghjkmnpqrstuvwxyz'
const DIGITS = '23456789'
const SPECIAL = '!@#$%&*-_=+'

export function generatePassword(): string {
  const all = UPPER + LOWER + DIGITS + SPECIAL
  const arr = new Uint8Array(14)
  crypto.getRandomValues(arr)
  const chars = Array.from(arr).map((b) => all[b % all.length])
  const mandatory = [
    UPPER[arr[0] % UPPER.length],
    LOWER[arr[1] % LOWER.length],
    DIGITS[arr[2] % DIGITS.length],
    SPECIAL[arr[3] % SPECIAL.length],
  ]
  for (let i = 0; i < mandatory.length; i++) chars[i] = mandatory[i]
  return chars.sort(() => Math.random() - 0.5).join('')
}

export function passwordStrength(pw: string): { score: number; label: string; color: string } {
  let score = 0
  if (pw.length >= 10) score++
  if (pw.length >= 14) score++
  if (/[A-Z]/.test(pw)) score++
  if (/[a-z]/.test(pw)) score++
  if (/[0-9]/.test(pw)) score++
  if (/[^A-Za-z0-9]/.test(pw)) score++
  if (score <= 2) return { score: (score / 6) * 100, label: 'Fraca', color: 'red' }
  if (score <= 4) return { score: (score / 6) * 100, label: 'Média', color: 'yellow' }
  return { score: (score / 6) * 100, label: 'Forte', color: 'teal' }
}
